import { Link } from "react-router-dom";

/**
 * NOVIFOOD wordmark — transparent PNG (blue letters).
 * `variant="white"` recolors it white via CSS filter for use on dark backgrounds.
 */
export default function Logo({
    className = "",
    size = "md",
    to = "/",
    testId = "logo",
    variant = "default",
}) {
    const sizes = {
        sm: "h-6",
        md: "h-8",
        lg: "h-10",
    };

    // brightness(0) collapses all colors to black (preserving alpha),
    // then invert(1) flips black → white. Result: pure white silhouette.
    const recolor =
        variant === "white" ? { filter: "brightness(0) invert(1)" } : undefined;

    return (
        <Link
            to={to}
            data-testid={testId}
            aria-label="NOVIFOOD"
            className={`inline-flex items-center leading-none ${className}`}
        >
            <img
                src="/brand/novifood-logo.png"
                alt="NOVIFOOD"
                draggable={false}
                className={`${sizes[size]} w-auto select-none block`}
                style={{ objectFit: "contain", ...recolor }}
            />
        </Link>
    );
}
